import React from 'react'
import { find, map, orderBy, last } from 'lodash'
import getSymbolFromCurrency from 'currency-symbol-map'
import { parse, format } from 'date-fns'
import { ellipsifyByChar } from '~/tools/strings/ellipsify'
import { getMyBillingHistory } from '~/redux/user/subscription'
import connect from '~/tools/connect'
import { fetchModels } from '~/redux/models/helpers'
import userStore from '~/redux/user/store'
import './style.css'

class View extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  async componentDidMount() {
    this.setState({ model: await fetchModels() })
    getMyBillingHistory().then( r => {
      this.setState({
        ...this.state,
        billingHistory: {
          ...r.data,
          Items: orderBy( r.data.Items, item => parse(item.initiatedAt), 'desc')
        }
      })
    })
  }

  capitalize(string) {
    var str = string.toLowerCase()
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  formatDate(date) {
    return format(date, 'MM/DD/YYYY')
  }

  render() {
    const billingHistory = this.state.billingHistory

    if (!this.state.billingHistory) {
      return null
    } else if (!billingHistory.Items.length) {
      return <div className="centered">No billing history available</div>
    }

    if (!this.state.user.subscription) { 
      return (
        <div className="billing-history centered padded">
          <div className="transactions-wrapper">
            <div className="transactions">
              <h1>Billing History</h1>
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Applied Offers</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.billingHistory && this.renderBillingHistoryItems()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )
    }

    const subscription = this.state.user.subscription
    const { countryCode, subscriptionEndDate } = subscription.subscriptionInfo || {}
    const actualPrice = find(subscription.subscriptionPlanInfo.planDetails, { countryCode: countryCode })

    var isActiveSubscription = this.state.user.subscription.subscriptionInfo.subscriptionStatus !== 'CANCELLED'
    var userWillBeCharged = this.state.user.subscription.subscriptionInfo.subscriptionStatus === 'COMPLETED'

    return (
      <div className="billing-history centered padded">
          { isActiveSubscription && (
            <div className="plan-info">
              <div className="title">{subscription.subscriptionPlanInfo.name}</div>
              <div className="desc">{subscription.subscriptionPlanInfo.description}</div>
            {actualPrice && <div className="price">
                {getSymbolFromCurrency(subscription.subscriptionInfo.currencyCode)}{actualPrice.recurringPaymentAmount} per {subscription.subscriptionPlanInfo.renewalCycleType.toLowerCase()}
              </div>}

            </div>
          ) }
          <div className="major-dates">
            <span className="join-date">
              <b>Join Date: </b>
              { this.formatDate(last(billingHistory.Items).subscriptionStartDate) }
            </span><br />
            <span className="last-charge">
              <b>Last Charge: </b>
              { this.formatDate(billingHistory.Items[0].completedAt) }
            </span> <br />
            { userWillBeCharged && subscriptionEndDate && (
              <span className="next-charge">
                <b>Next Charge: </b>
                { this.formatDate(subscriptionEndDate) }
              </span>
            ) }
          </div>
          <div className="transactions-wrapper">
            <div className="transactions">
              <h1>Billing History</h1>
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Title</th>
                    <th>Service Period</th>
                    <th>Description</th>
                    <th>Applied Offers</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  { this.renderBillingHistoryItems() }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )
  }

  renderBillingHistoryItems() {
    return map(this.state.billingHistory.Items, (item, i) => {
      return <tr key={item.id} className="billing-item">
          <td className="date">
            { this.formatDate(item.initiatedAt || item.initiatedDate) }
          </td>
          <td className="title">
          { (item.title && ellipsifyByChar(item.title, 40)) || 'N/A' }
          </td>
          { this.state.model === 'SVOD' && item.purchaseType ? 
            <td className="service-period">
              { this.formatDate(item.subscriptionStartDate) } - { this.formatDate(item.subscriptionEndDate) }
            </td> : <td className="purchase-type">
            { item.purchaseType ? this.capitalize(item.purchaseType) : 'N/A' }
          </td> }
          <td className="description-type">
          { this.capitalize(item.transactiontype || item.transactionType) }
          </td>
          <td>{(item.offerName && item.offerName) || 'N/A'}</td>
          <td className="total">
            { getSymbolFromCurrency(item.currencyCode) }
            {item.totalAmount}
          </td>
        </tr>;
    })
  }
}

connect(View, state => ({ user: state.user }), userStore)

export default View;
